import React from "react";
import { Select, Spin } from "antd";
import { useEffect } from "react";
import axios from "axios";

const { Option } = Select;

export default function Filter(props) {
  const [options, setOptions] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);
  const mode = props.mode || "multiple";

  useEffect(() => {
    setFetching(true);
    axios.get(`${props.api}/${props.source}`).then((response) => {
      const values = response.data.map((v) => (
        <Option key={v} title={v.toString()}>
          {v}
        </Option>
      ));
      setFetching(false);
      setOptions(values);
    });
  }, [setOptions, props.api, props.source]);

  return (
    <Select
      mode={mode}
      style={{ width: "90%" }}
      placeholder={props.placeholder}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
      notFoundContent={fetching ? <Spin size="small" /> : null}
    >
      {options}
    </Select>
  );
}
